import styled from 'styled-components';
import clock from '~/assets/icons/clock.svg';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 30px;
	margin-top: 10px;
`;

const StyledInfoContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 20px;
`;

const StyledDivider = styled.div`
	width: 100%;
	height: 1px;
	background-color: rgba(255, 255, 255, 0.1);
`;

const StyledInfoBottomContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledPriceContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		font-weight: 700;
		font-size: 18px;
		color: #ffffff;
	}
`;

const StyledTimeContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		font-weight: 700;
		font-size: 18px;
		color: #ffffff;

		span {
			font-weight: 400;
			opacity: 0.5;
		}
	}
`;

const StyledButtonsContainer = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 20px;
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 10px;

	img {
		width: 20px;
		height: 20px;
	}
`;

const StyledClockIcon = styled.div`
	width: 16px;
	height: 16px;
	mask-image: url(${clock});
	mask-size: 100% 100%;
	mask-repeat: no-repeat;
	mask-position: center;
	-webkit-mask-image: url(${clock});
	-webkit-mask-size: 100% 100%;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-position: center;
	background-color: #ffbb00;
`;

export {
	StyledButtonContent,
	StyledButtonsContainer,
	StyledClockIcon,
	StyledContainer,
	StyledDivider,
	StyledInfoBottomContainer,
	StyledInfoContainer,
	StyledPriceContainer,
	StyledTimeContainer,
};
